import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type { AuthLoginReturn } from 'types/legacyDashboard';

const useLoginCall = () => {
  const callback = useCallback(async (email: string, password: string, rememberMe = false) => {
    const queryParams = new URLSearchParams({ rememberme: rememberMe ? '1' : '0' });
    const url = `${process.env.VITE_API_ROOT}/auth/session/?${queryParams}`;
    const result: AuthLoginReturn | undefined = await postFetcher({
      url,
      body: { email, password },
    });

    return result;
  }, []);

  return callback;
};

export default useLoginCall;
